import { render, staticRenderFns } from "./UploaderPage.vue?vue&type=template&id=1b72d60f&scoped=true&"
import script from "./UploaderPage.vue?vue&type=script&lang=js&"
export * from "./UploaderPage.vue?vue&type=script&lang=js&"
import style0 from "./UploaderPage.vue?vue&type=style&index=0&id=1b72d60f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b72d60f",
  null
  
)

export default component.exports